export default {
    "sectionsBlockHeaderTemplate": "componentsCompany/astraTop/CardSectionsBlockHeader",
    "sectionsBlockFooterTemplate": "componentsCompany/astraTop/CardSectionsBlockFooter",
    "sections": {
        "manual": {
            "showName": "Цели",
            "addElementButtonText": "Создать цель",
            "emptyText": "Нет личных целей",
            "hideOnStagesIfEmpty": [
                "assessment",
                ""
            ],
            "fieldsAvailableForEdit": {
                "scale.is_main": {
                    "stages": [
                        "plan",
                        "correction"
                    ],
                    "rules": [
                        "app\\build\\astraTop\\rbac\\businessRules\\AstraElementNotOpenedByCardUserWithoutPermissionRule"
                    ]
                },
                "weight": {
                    "stages": [
                        "plan",
                        "correction"
                    ],
                    "rules": [
                        "app\\build\\astraTop\\rbac\\businessRules\\AstraElementNotOpenedByCardUserRule"
                    ]
                },
                "library_element_id": {
                    "stages": [
                        "plan",
                        "correction"
                    ],
                    "rules": [
                        "app\\build\\astraTop\\rbac\\businessRules\\AstraElementNotOpenedByCardUserWithoutPermissionRule"
                    ]
                },
                "scale.tactic_kpi": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "scale.template_id": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "scale.scopes": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "scale.unit_id": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "scale.planned_bonus": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "scale.plan": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "comment.plan": {
                    "stages": [
                        "plan",
                        "correction"
                    ],
                    "skipElementEditPermissionsCheck": true
                },
                "card.info.planned_bonus_result": {
                    "stages": [
                        "plan",
                        "correction"
                    ],
                    "rules": [
                        "app\\build\\astraTop\\rbac\\businessRules\\AstraElementNotOpenedByCardUserRule"
                    ]
                },
                "card.info.options": {
                    "stages": [
                        "plan",
                        "correction"
                    ],
                    "rules": [
                        "app\\build\\astraTop\\rbac\\businessRules\\AstraElementNotOpenedByCardUserRule"
                    ]
                },
                "card.info.agreed_bonus_result": {
                    "stages": [
                        "assessment"
                    ],
                    "rules": [
                        "app\\build\\astraTop\\rbac\\businessRules\\AstraElementNotOpenedByCardUserRule"
                    ]
                },
                "scale.fact": {
                    "stages": [
                        "assessment"
                    ]
                },
                "scale.agreed_bonus": {
                    "stages": [
                        "assessment"
                    ],
                    "rules": [
                        "app\\build\\astraTop\\rbac\\businessRules\\AstraElementNotOpenedByCardUserRule"
                    ]
                },
                "comment.assessment": {
                    "stages": [
                        "assessment"
                    ],
                    "skipElementEditPermissionsCheck": true
                }
            }
        }
    },
    "default_columns": [
        {
            "label": "Главная",
            "width": 80,
            "template": "componentsCompany/astraTop/tableColumnTemplates/card/AstraTopElementIsMainTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Стратегическая цель",
            "minWidth": 200,
            "template": "componentsCompany/astraTop/tableColumnTemplates/card/AstraTopElementStrategyTargetTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Тактический KPI",
            "minWidth": 200,
            "template": "componentsCompany/astraTop/tableColumnTemplates/card/AstraTopElementTacticKpiTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Вес",
            "width": 70,
            "template": "componentsCompany/astraTop/tableColumnTemplates/card/AstraTopElementWeightTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Единица измерения",
            "width": 100,
            "template": "components/tableColumnTemplates/card/ElementLibraryUnitTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Шкала",
            "width": 210,
            "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScaleTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Плановая премия",
            "width": 160,
            "template": "componentsCompany/astraTop/tableColumnTemplates/card/AstraTopElementPlannedBonusTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "План",
            "width": 140,
            "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScalePlanTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Комментарий к цели",
            "width": 120,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'plan'",
                "last-comment": "scope.row.last_comment_by_stage['plan']",
                "comments-count": "scope.row.comments_count_by_stage['plan']"
            }
        },
        {
            "label": "Факт",
            "width": 240,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScaleFactTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Комментарий к факту",
            "width": 120,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'assessment'",
                "last-comment": "scope.row.last_comment_by_stage['assessment']",
                "comments-count": "scope.row.comments_count_by_stage['assessment']"
            }
        },
        {
            "label": "% Выполнения",
            "width": 120,
            "prop": "scale.fact_percent|numberFormat",
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true
        },
        {
            "label": "Фактическая премия",
            "prop": "scale.fact_bonus|numberFormat",
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "width": 110
        },
        {
            "label": "Утвержденная премия",
            "width": 120,
            "template": "componentsCompany/astraTop/tableColumnTemplates/card/AstraTopElementAgreedBonusTableColumn",
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "",
            "template": "components/tableColumnTemplates/card/ElementActionsTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            },
            "align": "'center'",
            "width": 50
        }
    ],
    "multiplier_columns": [
        {
            "label": "Название цели",
            "minWidth": 200,
            "template": "components/tableColumnTemplates/card/ElementNameTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Шкала",
            "width": 340,
            "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScaleTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Единица измерения",
            "width": 90,
            "template": "components/tableColumnTemplates/card/ElementLibraryUnitTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "План",
            "width": 140,
            "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScalePlanTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Комментарий к плану",
            "width": 120,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'plan'",
                "last-comment": "scope.row.last_comment_by_stage['plan']",
                "comments-count": "scope.row.comments_count_by_stage['plan']"
            }
        },
        {
            "label": "Факт",
            "width": 240,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScaleFactTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Комментарий к факту",
            "width": 120,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'assessment'",
                "last-comment": "scope.row.last_comment_by_stage['assessment']",
                "comments-count": "scope.row.comments_count_by_stage['assessment']"
            }
        },
        {
            "label": "% премии",
            "prop": "bonus",
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "width": 100
        },
        {
            "label": "",
            "template": "components/tableColumnTemplates/card/ElementActionsTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            },
            "align": "'center'",
            "width": 50
        }
    ]
}